<template>
  <div v-loading.fullscreen="loading" class="page-wrap">
    <template v-if="!hasInvestObject && !loading && ($store.state.role === 'admin' || $store.state.role === 'moderator')"
    >
      <NewChronologyForm/>
    </template>
    <template v-if="hasInvestObject && !loading">
      <div class="header">
        <div class="page-title">Шаффоф инвест малумотлари</div>
        <el-button
            size="small"
            @click="onClickEditButton"
            type="primary"
            style="margin-bottom: 15px"
        >Tahrirlash
        </el-button
        >
      </div>
      <el-dialog
          v-model="showEditModal"
          title="Malumotlarni tahrirlash"
          @close="closeEditModal"
          style="max-width: 600px"
          align-center
      >
        <el-form
            ref="desicionForm"
            :model="desicionForm"
            :rules="rulesDesicion"
            label-position="top"
            style="width: 100%"
            status-icon
        >
          <div class="demo-collapse">
            <el-collapse v-model="activeNames">
              <el-collapse-item title="Kengash qarorini yuklash:" name="1" v-loading="desicionLoading">
                <div>
                  <el-form-item>
                    <el-select style="width: 100%"
                               v-model="selectedDesicion"
                               clearable
                               class="m-2" placeholder="Select"
                               size="large">
                      <el-option
                          v-for="item in councilDesicions"
                          :key="item.id"
                          :label="item.title"
                          :value="item.id"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item
                      v-if="!selectedDesicion"
                      label="Hujjat nomi va sanasi"
                      prop="title"
                  >
                    <el-input
                        size="large"
                        v-model="desicionForm.title"
                        placeholder="Ma'lumot kiriting"
                    />
                  </el-form-item>

                  <el-form-item
                      v-if="!selectedDesicion"
                      label="Xujjat faylini yuklang"
                      prop="file_id"
                  >
                    <el-upload
                        v-model:file-list="resultFileList"
                        :action="fileUploadUrl"
                        :headers="fileUploadHeader"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        :multiple="false"
                        :limit="1"
                        :on-success="onSuccessFileUpload"
                        :on-remove="handleRemoveFile"
                    >
                      <el-button
                          type="primary"
                          :disabled="resultFileList.length > 0"
                      >Faylini yuklang
                      </el-button
                      >
                    </el-upload>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="onSave">
                      Saqlash
                    </el-button>
                  </el-form-item>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-form>

        <el-form
            ref="editForm"
            :model="editForm"
            :rules="rules"
            label-position="top"
            style="width: 100%"
            status-icon
        >
          <div class="demo-collapse">
            <el-collapse v-model="activeNames">
              <el-collapse-item
                  title="Қурилиш-таъмирлаш ишларини якунлаш ва топшириш:"
                  name="2"
              >
                <el-form-item label="Фойдаланишга топширилган сана">
                  <el-date-picker
                      v-model="editForm.date_put_into_use"
                      type="date"
                      placeholder="Sana tanlang"
                      style="width: 100%"
                  />
                </el-form-item>

                <el-form-item label="Қабул қилган орган номи">
                  <el-input
                      size="large"
                      v-model="editForm.received_org"
                      placeholder="malumot kiriting"
                  />
                </el-form-item>
                <el-form-item label="Yakuniy qiymati" prop="final_value">
                  <el-input
                      size="large"
                      class="form-input"
                      v-model="editForm.final_value"
                      v-money="money"
                      type="text"
                  />
                </el-form-item>
                <el-form-item>
                  <el-button @click="closeEditModal">Bekor qilish</el-button>
                  <el-button type="primary" @click="editFunction">
                    Saqlash
                  </el-button>
                </el-form-item>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-form>
      </el-dialog>
      <NewChronologyDetail :chronology="chronology.list"/>
    </template>
  </div>
</template>

<script>
import {ElNotification} from "element-plus";
import NewChronologyForm from "@/views/newchronology/NewChronologyForm.vue";
import NewChronologyDetail from "@/views/newchronology/NewChronologyDetail.vue";

export default {
  components: {
    NewChronologyForm,
    NewChronologyDetail,
  },
  data() {
    return {
      fileUploadUrl: `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`,
      fileUploadHeader: {Authorization: `${this.$store.state.accessToken}`},
      loading: false,
      hasInvestObject: false,
      showEditModal: false,
      resultFileList: [],
      editForm: {
        id: null,
        orderer_document_name: null,
        orderer_document_file: null,

        date_put_into_use: "",
        received_org: null,
        final_value: null,
      },
      activeNames: '1',
      form: {
        openbudget_id: null,
      },
      desicionLoading: false,
      desicionForm: {
        file_id: null,
        board_id: null,
        region_id: null,
        district_id: null,
        title: null
      },
      initiativeId: null,
      selectedDesicion: null,
      councilDesicions: [],
      rulesDesicion: {
        title: {
          required: true,
          message: "Majburiy maydon.",
        },
        file_id: {
          required: true,
          message: "Majburiy maydon.",
        }
      },
      rules: {
        orderer_document_name: [
          {
            required: true,
            message: "Majburiy maydon.",
          },
        ],
        orderer_document_file: [
          {
            required: true,
            message: "Majburiy maydon.",
          },
        ],

        orderer_document_num: [
          {
            required: true,
            message: "Majburiy maydon.",
          },
        ],
        orderer_document_date: [
          {
            required: true,
            message: "Majburiy maydon.",
          },
        ],
      },
      money: {
        decimal: ".",
        thousands: " ",
        prefix: "",
        suffix: "",
        precision: 0,
      },
      chronology: {
        list: [
          {
            id: 1,
            orderer_title: "Буюртмачи ташкилотни белгилаш",
          },
          {
            id: 2,
            orderer_title: "Лойихачи ташкилотни аниклаш",
          },
          {
            id: 3,
            orderer_title: "Пудратчи ташкилотни аниқлаш ва молиялаштириш",
          },
          {
            id: 4,
            orderer_title: "Қурилиш-таъмирлаш ишларини якунлаш ва топшириш",
          },
        ],
        loader: false,
      },
    };
  },
  mounted() {
    this.form.openbudget_id = this.$route.params.public_id;
    this.desicionForm.board_id = parseInt(this.$route.query.board_id);
    this.desicionForm.region_id = parseInt(this.$route.query.region_id);
    this.desicionForm.district_id = parseInt(this.$route.query.district_id);
    this.initiativeId = this.$route.query.id;
    if (this.$route.query.council_decision_id) {
      this.selectedDesicion = parseInt(this.$route.query.council_decision_id);
    }

    this.getByInvestId();
  },
  methods: {
    onSave() {
      this.$refs.desicionForm.validate((valid) => {
        if (valid) {
          this.desicionLoading = true;
          if (this.selectedDesicion) {
            this.onSubmitSelectableFile();
          } else {
            this.onCouncilDesicionUpload()
          }
        }
      })

    },
    onCouncilDesicionUpload() {
      this.$http.post(`api/v1/init-council-decisions`, this.desicionForm)
          .then(({data}) => {
            this.selectedDesicion = data.id;
            this.onSubmitSelectableFile();
            this.showEditModal = false
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Saqlashda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.desicionLoading = false;
          })
    },
    onSubmitSelectableFile() {
      this.$http.post(`api/v1/initiatives/council-decision`, {
        initiative_id: this.initiativeId,
        council_decision_id: this.selectedDesicion
      })
          .then(() => {
            ElNotification.success({
              message: "Ma'lumotlar saqlandi",
            });
            this.showEditModal = false
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Saqlashda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.desicionLoading = false;
          })
    },
    onClickEditButton() {
      this.showEditModal = true;
      this.getCouncilDesicions();
    },
    getCouncilDesicions() {
      this.loading = true;
      this.$http
          .get(`api/v1/init-council-decisions`, {
            params: {
              limit: 100
            }
          })
          .then(({data}) => {
            this.councilDesicions = data.data
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },

    handleRemoveFile() {
      this.resultFileList = [];
      this.editForm.orderer_document_file = null;
    },
    onSuccessFileUpload(res) {
      this.editForm.orderer_document_file = res.hashId;
      this.desicionForm.file_id = res.hashId
      // console.log(res.hashId);
    },

    closeEditModal() {
      this.showEditModal = false;
    },

    formattedDateTime(dateString) {
      const dateObj = new Date(dateString);

      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, "0");
      const day = String(dateObj.getDate()).padStart(2, "0");

      const formattedDate = `${year}-${month}-${day}`;
      return dateString ? formattedDate : null;
    },

    editFunction() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          const data = {
            ...this.editForm,
            orderer_document_date: this.formattedDateTime(
                this.editForm.orderer_document_date
            ),
            date_put_into_use: this.formattedDateTime(
                this.editForm.date_put_into_use
            ),
          };
          if (data.final_value) {
            data.final_value = parseFloat(data.final_value.replace(/\s/g, ""));
          }
          this.loading = true;
          this.$http
              .put(`api/v1/chronology`, data)
              .then(() => {
                ElNotification.success({
                  message: "Muvofaqqiyatli amalga oshirildi!",
                });
                this.closeEditModal();
                this.getByInvestId();
              })
              .catch((error) => {
                console.log(error);
                ElNotification.error({
                  message:
                      "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      });
    },
    getByInvestId() {
      this.loading = true;
      this.$http
          .get(`api/v1/chronology?public_id=${this.form.openbudget_id}`)
          .then(({data}) => {
            this.hasInvestObject = true;
            const first = this.chronology.list.find((item) => item.id === 1);
            const second = this.chronology.list.find((item) => item.id === 2);
            const third = this.chronology.list.find((item) => item.id === 3);
            const fourth = this.chronology.list.find((item) => item.id === 4);
            const info = data.invest_object.data[0] || {};
            first.customerName = info.customerName;
            first.customerTin = info.customerTin;
            first.customerDirector = info.customerDirector;
            first.Accounts = info.Accounts;
            first.distributedSumma = info.distributedSumma;
            first.paidOnlineSumma = info.paidOnlineSumma;
            first.lastAmount =
                info?.distributedSumma && info?.paidOnlineSumma
                    ? info?.distributedSumma - info?.paidOnlineSumma
                    : "aniqlanmagan";
            first.orderer_document_name = data?.orderer_document_name;
            first.orderer_document_date = data?.orderer_document_date;
            first.orderer_document_file = data?.orderer_document_file;
            first.orderer_document_num = data?.orderer_document_num;
            second.designerName = info.designerName;
            second.designerTin = info.designerTin;
            second.designerDirector = info.designerDirector;
            second.designerLots = info.designerLots;

            third.builderName = info.builderName;
            third.builderTin = info.builderTin;
            third.builderLots = info.builderLots;
            third.constructionTypeName = info.constructionTypeName;
            third.periodicityName = info.periodicityName;
            third.implementationPeriod = info.implementationPeriod;

            fourth.date_put_into_use = data.date_put_into_use;
            fourth.received_org = data.received_org;

            this.editForm.id = data.id;
            this.editForm.orderer_document_name = data.orderer_document_name;
            this.editForm.orderer_document_date =
                data.orderer_document_date || "";
            this.editForm.orderer_document_file = data.orderer_document_file;
            this.editForm.orderer_document_num = data.orderer_document_num;
            this.editForm.received_org = data.received_org;
            this.editForm.date_put_into_use = data.date_put_into_use || "";
            this.editForm.final_value = data.final_value;

            ElNotification.success({
              message: "Success",
            });
          })
          .catch((error) => {
            console.log(error.response.status)
            if (error.response.status === 404) {
              this.hasInvestObject = false;
              return;
            }
            console.log(error);
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onBeforeUpload(file) {
      console.log(file);
      // Return false to prevent the file from being uploaded immediately
      return false;
    },
    onErrorUpload(error) {
      if (error.status === 401) {
        this.$store.commit("signOut");
        this.$router.push({name: "Auth"});
      }
      ElNotification.error({
        message:
            JSON.parse(error?.message)?.message ||
            "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
        type: "error",
      });

      this.loading = false;
    },
    onExceed() {
      console.log("exceeds");
      // this.form.file[0] = files[0]
    },
  },
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
</style>
